import { useEffect } from "react";

export function useDedupEffect(
  fn: React.EffectCallback,
  dependencies: React.DependencyList
) {
  useEffect(() => {
    let hasExecuted = false;
    if (!hasExecuted) {
      fn();
    }
    return () => {
      hasExecuted = true;
    };
    // eslint-disable-next-line
  }, dependencies);
}

export function downloadPDF(source: string) {
  window.open(source, "_blank");
}
